import React, { useState } from "react";
import {
  Button,
  Form,
  Label,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
} from "reactstrap";
import AuthFooter from "../../components/Footers/AuthFooter";
import { hideLoader, showLoader } from "../../redux/actions/loader-data";
import { showToast } from "../../helper-methods";
import { forgotPassword } from "../../http/http-calls";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { RegexConfig } from "../../config/RegexConfig";
import { APP_LOGO, APP_NAME, LOGIN_PAGE_BANNER } from "../../config/index";

const ForgotPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState({
    handle: "",
  });
  const [isDirty, setIsDirty] = useState({
    handle: false,
  });
  const [errors, setErrors] = useState({});

  const _validateFormFields = (newCredentials, newIsDirty) => {
    return new Promise((resolve) => {
      const newErrors = { ...errors };
      let isFormValid = true;

      Object.keys(newCredentials).forEach((key) => {
        if (newIsDirty[key]) {
          switch (key) {
            case "handle": {
              if (newCredentials[key]?.trim().length) {
                if (
                  RegexConfig.email.test(
                    String(newCredentials[key]).toLowerCase()
                  )
                ) {
                  delete newErrors[key];
                  newIsDirty[key] = false;
                } else {
                  newErrors[key] = "*Invalid email";
                  isFormValid = false;
                }
              } else {
                newErrors[key] = "*Required";
                isFormValid = false;
              }
              break;
            }
            default:
          }
        }
      });

      setErrors(newErrors);
      setIsDirty(newIsDirty);

      resolve(isFormValid);
    });
  };

  const _onChangeFormFields = (key, value) => {
    const newCredentials = { ...credentials };
    const newIsDirty = { ...isDirty };
    newCredentials[key] = value;
    newIsDirty[key] = true;
    setCredentials(newCredentials);
    setIsDirty(newIsDirty);
    _validateFormFields(newCredentials, newIsDirty);
  };

  const _onSubmitForm = async (event) => {
    if (event) event.preventDefault();

    const newIsDirty = {
      handle: true,
    };

    const isFormValid = await _validateFormFields(credentials, newIsDirty);

    if (isFormValid) {
      dispatch(showLoader("Loading..."));

      forgotPassword(credentials)
        .then((res) => {
          dispatch(hideLoader());
          showToast(
            "We have emailed the reset password instructions.",
            "success"
          );
          history.push("/home");
        })
        .catch((error) => {
          console.log("error>>", error);
          dispatch(hideLoader());
          showToast(
            error?.reason?.length
              ? error.reason
              : "Server error, Try again after sometime.",
            "error"
          );
        });
    }
  };

  return (
    <div className="vayco-public login_singup">
      <div className="app animated fadeIn ">
        <div className="login_wrapper d-flex align-items-center">
          <div className="login_left"></div>
          <div className="login_right ">
            <div className="login_Container forgotForm">
              <div className="form-title text-center">
                <img
                  src={APP_LOGO}
                  alt="Project Logo"
                  onClick={() => history.push("/home")}
                  className="projectLogo"
                />
                {/* <h2>{APP_NAME}</h2> */}
                <h4>Forgot Password</h4>
              </div>

              <Form onSubmit={(e) => _onSubmitForm(e)}>
                <FormGroup>
                  <Label>Email Address</Label>
                  <InputGroup>
                    <InputGroupText>
                      <i className="fas fa-user" />
                    </InputGroupText>
                    <Input
                      type="text"
                      placeholder="Enter your email"
                      autoComplete="off"
                      name="handle"
                      value={credentials.handle}
                      onChange={(e) =>
                        _onChangeFormFields("handle", e.target.value)
                      }
                    />
                  </InputGroup>
                  {errors["handle"] ? (
                    <div className="form-error">{errors["handle"]}</div>
                  ) : null}
                </FormGroup>

                <div className="d-flex flex-column align-items-center justify-content-center">
                  <Button color="primary" type="submit" className="btn-submit">
                    Forgot Password
                  </Button>
                  <Button
                    className="d-block back-login my-2 fs-15"
                    onClick={() => history.push("/login")}
                  >
                    <i className="fa fa-arrow-left mr-2" />
                    Back to Login
                  </Button>
                </div>
              </Form>
            </div>
            <AuthFooter />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
